<section class="section-div">
  <div class="header-div">
    <h4>
      <ion-icon name="earth-outline"></ion-icon> Social Impact -
      {{ incubaterName }}
    </h4>
  </div>
  <div class="content-details">
    <div class="content-div mb-2">
      <div class="d-flex" *ngIf="mobileQuery.matches == false">
        <h5 class="mb-3">Questions</h5>
      </div>

      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
          <mat-accordion>
            <!-- qusetion 001 -->
            <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
              <mat-expansion-panel-header class="d-flex">
                <h6>01.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Women led Startups with minimum 51% Stake with a woman
                    founder or co-founder
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.womenLedStartupsStatus)"
                    [style.background]="
                      pickColor(getValue.womenLedStartupsStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                    27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.womenLedStartupsStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Women led Startups with minimum 51% Stake with a woman
                    founder or co-founder
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.womenLedStartupsIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.womenLedStartupsIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            Percentage of Women-led Startups :
                            <b>{{ getValue.womenledStartupFoundersPercent }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            Total no. of incubated Startups :
                            <b>{{ getValue.womenledStartupFoundersCount }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.womenLedStartupsDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.womenLedStartupsStatus == 3 ||
                            getValue.womenLedStartupsStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.womenLedStartupsReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[0])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.womenLedStartupsStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('womenLedStartupsStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('womenLedStartupsStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.womenLedStartupsStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('womenLedStartupsStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 002 -->
            <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)">
              <mat-expansion-panel-header class="d-flex">
                <h6>02.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    SC / ST Founders with minimum 51% Stake with SC/ST founder
                    or co-founder
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.scstFoundersStatus)"
                    [style.background]="pickColor(getValue.scstFoundersStatus)"
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                            27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.scstFoundersStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    SC / ST Founders with minimum 51% Stake with SC/ST founder
                    or co-founder
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.scstFoundersIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.scstFoundersIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No of SC/ST Founders :
                            <b>{{ getValue.scstStartupFoundersCount }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.scstFoundersDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.scstFoundersStatus == 3 ||
                            getValue.scstFoundersStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.scstFoundersReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[1])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.scstFoundersStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('scstFoundersStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('scstFoundersStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.scstFoundersStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('scstFoundersStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 003 -->
            <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)">
              <mat-expansion-panel-header class="d-flex">
                <h6>03.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Programs on Circular Economy / Rural Impact Startups /
                    Alternate Livelihood
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.programsOnCircularStatus)"
                    [style.background]="
                      pickColor(getValue.programsOnCircularStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                            27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.programsOnCircularStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Programs on Circular Economy / Rural Impact Startups /
                    Alternate Livelihood
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.programsOnCircularPresent == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.programsOnCircularPresent }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No of Startups :
                            <b>{{ getValue.programsOnCircularNoOfPrograms }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.programsOnCircularDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.programsOnCircularStatus == 3 ||
                            getValue.programsOnCircularStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.programsOnCircularReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[2])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.programsOnCircularStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('programsOnCircularStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('programsOnCircularStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.programsOnCircularStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('programsOnCircularStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 004 -->
            <mat-expansion-panel [expanded]="step === 3" (opened)="setStep(3)">
              <mat-expansion-panel-header class="d-flex">
                <h6>04.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Startups working on Environmental Sustainability / Electric
                    Vehicles / Climate Resilience / SDG goals / Renewable Energy
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.environmentalSustainabilityStatus)
                    "
                    [style.background]="
                      pickColor(getValue.environmentalSustainabilityStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                            27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.environmentalSustainabilityStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Startups working on Environmental Sustainability / Electric
                    Vehicles / Climate Resilience / SDG goals / Renewable Energy
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.environmentalSustainabilityIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{
                              getValue.environmentalSustainabilityIncCentre
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No of Startups :
                            <b>{{
                              getValue.environmentalSustainabilityNoOfStartup
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.environmentalSustainabilityDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.environmentalSustainabilityStatus == 3 ||
                            getValue.environmentalSustainabilityStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.environmentalSustainabilityReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[3])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.environmentalSustainabilityStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="
                          approveBtn('environmentalSustainabilityStatus', 4)
                        "
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="
                          reviewBtn('environmentalSustainabilityStatus', 3)
                        "
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.environmentalSustainabilityStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="
                          rejectBtn('environmentalSustainabilityStatus', 6)
                        "
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 005 -->
            <mat-expansion-panel [expanded]="step === 4" (opened)="setStep(4)">
              <mat-expansion-panel-header class="d-flex">
                <h6>05.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Funding facilitated for Startups by Women / SC&ST /
                    Transperson Incubatees
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.fundFacilitatedForStartupStatus)
                    "
                    [style.background]="
                      pickColor(getValue.fundFacilitatedForStartupStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                            27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.fundFacilitatedForStartupStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Funding facilitated for Startups by Women / SC&ST /
                    Transperson Incubatees
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.fundFacilitatedForStartupPresent == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{
                              getValue.fundFacilitatedForStartupPresent
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No of Startups :
                            <b>{{
                              getValue.fundFacilitatedForStartupNoOfStartup
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.fundFacilitatedForStartupDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.fundFacilitatedForStartupStatus == 3 ||
                            getValue.fundFacilitatedForStartupStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.fundFacilitatedForStartupReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[4])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.fundFacilitatedForStartupStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="
                          approveBtn('fundFacilitatedForStartupStatus', 4)
                        "
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="
                          reviewBtn('fundFacilitatedForStartupStatus', 3)
                        "
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.fundFacilitatedForStartupStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="
                          rejectBtn('fundFacilitatedForStartupStatus', 6)
                        "
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 006 -->
            <mat-expansion-panel [expanded]="step === 5" (opened)="setStep(5)">
              <mat-expansion-panel-header class="d-flex">
                <h6>06.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Is incubated SC/ST led Startups applied for Tamil Nadu SC/ST
                    Startup Fund
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.incubatesScStStatus)"
                    [style.background]="pickColor(getValue.incubatesScStStatus)"
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                            27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.incubatesScStStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Is incubated SC/ST led Startups applied for Tamil Nadu SC/ST
                    Startup Fund
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.incubatesScStCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.incubatesScStCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No of Startups :
                            <b>{{ getValue.incubatesScStNoOfStartup }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.incubatesScStDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.incubatesScStStatus == 3 ||
                            getValue.incubatesScStStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.fundFacilitatedForStartupReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[5])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.incubatesScStStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('incubatesScStStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('incubatesScStStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.incubatesScStStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('incubatesScStStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 007 -->
            <mat-expansion-panel [expanded]="step === 6" (opened)="setStep(6)">
              <mat-expansion-panel-header class="d-flex">
                <h6>07.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Initiatives to support Rural development through technology
                    & Entrepreneurship and collaborations / hands-on trainings
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.ruralandRuralEntrepreneursStatus)
                    "
                    [style.background]="
                      pickColor(getValue.ruralandRuralEntrepreneursStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                        27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.ruralandRuralEntrepreneursStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Initiatives to support Rural development through technology
                    & Entrepreneurship and collaborations / hands-on trainings
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.ruralandRuralEntrepreneursIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{
                              getValue.ruralandRuralEntrepreneursIncCentre
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of initiatives / programs :
                            <b>{{
                              getValue.ruralandRuralEntrepreneursNoOfInitiative
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.ruralandRuralEntrepreneursDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.ruralandRuralEntrepreneursStatus == 3 ||
                            getValue.ruralandRuralEntrepreneursStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.ruralandRuralEntrepreneursReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[6])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.ruralandRuralEntrepreneursStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="
                          approveBtn('ruralandRuralEntrepreneursStatus', 4)
                        "
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="
                          reviewBtn('ruralandRuralEntrepreneursStatus', 3)
                        "
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.ruralandRuralEntrepreneursStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="
                          rejectBtn('ruralandRuralEntrepreneursStatus', 6)
                        "
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 008 -->
            <mat-expansion-panel [expanded]="step === 7" (opened)="setStep(7)">
              <mat-expansion-panel-header>
                <h6>08.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Employment generation by incubated Startups
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.employmentGenerationStatus)
                    "
                    [style.background]="
                      pickColor(getValue.employmentGenerationStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                                    27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.employmentGenerationStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>Employment generation by incubated Startups</h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.employmentGenerationIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.employmentGenerationIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No of Employment Generated :
                            <b>{{
                              getValue.employmentGenerationNoOfEmploymentGeneration
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.employmentGenerationDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.employmentGenerationStatus == 3 ||
                            getValue.employmentGenerationStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.employmentGenerationReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[7])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.employmentGenerationStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('employmentGenerationStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('employmentGenerationStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.employmentGenerationStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('employmentGenerationStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 009 -->
            <mat-expansion-panel [expanded]="step === 8" (opened)="setStep(8)">
              <mat-expansion-panel-header class="d-flex">
                <h6>09.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Innovative Startups among Incubatees solving local community
                    centric problems
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.innovativeStartupsStatus)"
                    [style.background]="
                      pickColor(getValue.innovativeStartupsStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                            27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.innovativeStartupsStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Innovative Startups among Incubatees solving local community
                    centric problems
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.innovativeStartupsIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.innovativeStartupsIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No of Startups :
                            <b>{{ getValue.innovativeStartupsNoOfStartup }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.innovativeStartupsDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.innovativeStartupsStatus == 3 ||
                            getValue.innovativeStartupsStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.innovativeStartupsReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[8])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.innovativeStartupsStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('innovativeStartupsStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('innovativeStartupsStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.innovativeStartupsStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('innovativeStartupsStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
              </mat-action-row>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
</section>
